import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider, FieldArray, getIn, Formik, Field } from 'formik';
import { connect } from "react-redux";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { DropzoneArea } from "material-ui-dropzone";
// material
import {
    Link,
    Card,
    Stack,
    Checkbox,
    TextField,
    IconButton,
    InputAdornment,
    FormControlLabel,
    Container,
    Typography,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    Grid,
    MenuItem,
    Button,
    TextareaAutosize,
    TableHead,
    Paper
} from '@mui/material';
import { ListHead, ListToolbar, MoreMenu } from '../../components/_dashboard/car';
import { LoadingButton } from '@mui/lab';
import Scrollbar from '../../components/Scrollbar';
import { installmentsCreate, installmentsUpdate, installmentReceived, scheduleUpdate } from '../../actions/installmentAction';
import _ from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';
import Edit from "@material-ui/icons/Edit";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ModalCompoennt from '../Portal/ModalCompoennt';


// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));

const TABLE_HEAD = [
    { id: 'id', label: 'ID', alignRight: false },
    { id: 'name', label: 'Name', alignRight: false },
    { id: 'email', label: 'Email', alignRight: false },
    { id: 'action', label: 'Actions', alignRight: false },
];

const min = 1;
const date = new Date();
const f_date = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
let datearray = [];
let calculated_values = [];

function ReceiveInstallment(props) {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [adminObj, setAdminObj] = useState({});
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [files, setFiles] = useState([]);
    const [value, setValue] = useState('');
    const [amountPaid, setAmountPaid] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [extra, setExtra] = useState(0);
    const [remaining, setRemaining] = useState(0);

    useEffect(() => {
        setIsLoading(false);
        if(props.alerts.status == 'success') {
            props.onDismis();
        }
        if(props.alerts.status == 'success') {
            navigate('/dashboard/installments', { replace: true });
        }
    }, [props.alerts]);

    const handleAmountPaid = (e) => {
        let amount_paid = e.target.value;
        let agreed_amount_paid = calculated_values[currentIndex].amt_due;
        if(amount_paid > agreed_amount_paid) {
            setAmountPaid(amount_paid);
            document.getElementById(`extra${currentIndex}`).value = amount_paid-agreed_amount_paid;
            let ex = amount_paid-agreed_amount_paid;
            setExtra(ex);
            document.getElementById(`remaining${currentIndex}`).value = 0;
            setRemaining(0);
        }
        if(amount_paid < agreed_amount_paid) {
            setAmountPaid(amount_paid);
            document.getElementById(`extra${currentIndex}`).value = 0;
            setExtra(0);
            document.getElementById(`remaining${currentIndex}`).value = agreed_amount_paid-amount_paid;
            setRemaining(agreed_amount_paid-amount_paid);
        }
        if(amount_paid == agreed_amount_paid) {
            setAmountPaid(amount_paid);
            setExtra(0);
            document.getElementById(`remaining${currentIndex}`).value = 0;
            document.getElementById(`extra${currentIndex}`).value = 0;
            setRemaining(0);
        }
        if(amount_paid == 0) {
            document.getElementById(`remaining${currentIndex}`).value = agreed_amount_paid-amount_paid;
            setRemaining(agreed_amount_paid-amount_paid);
        }
        if(amount_paid == '') {
            document.getElementById(`remaining${currentIndex}`).value = 0;
            setRemaining(0);
        }
    }

    const renderAmountPaid = (index, d) => {
        let arr = [];
        if(!_.isEmpty(props.installment.payment_history)) {
            props.installment.payment_history.map((p, index) => {
                arr[index] = p.amount_paid;
            });
        }
        if(arr[index-1] !== undefined) {
            return <>
                <TableCell>
                    {arr[index-1]}
                </TableCell>
            </>
        } else {
            return <>
                <TableCell>
                    <TextField 
                        name="amount_paid" 
                        required 
                        type='number'
                        label="Amount Paid"
                        InputProps={{ inputProps: { min: 0, step: 'any' } }}
                        autoComplete='off'
                        disabled={(new Date(d).getMonth() == new Date().getMonth() && d.getFullYear() == new Date().getFullYear() ? false : true)}
                        onChange={(e) => handleAmountPaid(e)}
                    />
                </TableCell>
            </>
        }
    }

    const renderExtra = (index, d) => {
        let arr = [];
        if(!_.isEmpty(props.installment.payment_history)) {
            props.installment.payment_history.map((p, index) => {
                arr[index] = p.extra;
            });
        }
        if(arr[index-1] !== undefined) {
            return <>
                <TableCell>
                    {arr[index-1]}
                </TableCell>
            </>
        } else {
            return <>
                <TextField name={`extra${index}`} id={`extra${index}`} type='number' disabled sx={{border:"none"}} />
            </>
        }
    }

    const renderRemaining = (index, d) => {
        let arr = [];
        if(!_.isEmpty(props.installment.payment_history)) {
            props.installment.payment_history.map((p, index) => {
                arr[index] = p.remaining;
            });
        }
        if(arr[index-1] !== undefined) {
            return <>
                <TableCell>
                    {arr[index-1]}
                </TableCell>
            </>
        } else {
            return <>
                <TextField name={`remaining${index}`} id={`remaining${index}`} type='number' disabled sx={{border:"none"}} />
            </>
        }
    }

    const renderTableBody = () => {
        let beg_balance = 0;
        let remaining_balances = [];
        if(!_.isEmpty(props.installment.payment_history)) {
            const data = props.installment.payment_history;
            let last = data.slice(-1);
            beg_balance = last[0].ending_balance;
        } else {
            beg_balance = 0;
        }
        let startdate = new Date(props.installment.start_date); 
        let loan_amount = props.installment.loan_amount;
        let number_of_payments = props.installment.number_of_payments;
        for(let i=1;i<=number_of_payments;i++) {
            let cur_date = new Date(startdate);
            let currentdate = startdate.setMonth(startdate.getMonth()+1);
            datearray[i] = cur_date;
            if(!_.isEmpty(props.installment.payment_history[i-1])){
                remaining_balances[i] = props.installment.payment_history[i-1].remaining;
                calculated_values[i] = {
                    'beg_amt':props.installment.payment_history[i-1].beginning_balance,
                    'ending_balance': props.installment.payment_history[i-1].ending_balance,
                    'amt_due':props.installment.payment_history[i-1].amount_due,
                    'due_date':cur_date.getFullYear()+'-'+(cur_date.getMonth()+1)+'-'+cur_date.getDate()
                };
            } else {
                let ending_balance = beg_balance == 0 ? loan_amount-props.installment.payment_amount : remaining_balances[i-1] > 0 ? beg_balance-props.installment.payment_amount-remaining_balances[i-1] : beg_balance-props.installment.payment_amount;
                let loan = beg_balance == 0 ? loan_amount : beg_balance;
                beg_balance = ending_balance;
                calculated_values[i] = {
                    'beg_amt':loan,
                    'ending_balance': i == number_of_payments ? 0 :  ending_balance,
                    'amt_due': remaining_balances[i-1] > 0  ? props.installment.payment_amount+remaining_balances[i-1] : props.installment.payment_amount,
                    'due_date':cur_date.getFullYear()+'-'+(cur_date.getMonth()+1)+'-'+cur_date.getDate()
                };  
            }   
        }
        if(!_.isEmpty(datearray) && !_.isEmpty(props.installment)) {
            return datearray.map((d, index) => {
                d.getMonth()+1 == new Date().getMonth()+1 && d.getFullYear() == new Date().getFullYear() ? setCurrentIndex(index) : '';
                return <>
                        <TableRow key={index}>
                            <TableCell>
                                {index}
                            </TableCell>
                            <TableCell>
                                {new Date(d).toLocaleDateString()}
                            </TableCell>
                            <TableCell>
                                {calculated_values[index].beg_amt}
                            </TableCell>
                            <TableCell>
                                {calculated_values[index].amt_due}
                            </TableCell>
                                {renderAmountPaid(index, d)}
                            <TableCell>
                                {renderExtra(index, d)}
                            </TableCell>
                            <TableCell>
                                {renderRemaining(index, d)}
                            </TableCell>
                            <TableCell>
                                {calculated_values[index].ending_balance}
                            </TableCell>
                        </TableRow>
                </>
            });
        }
    }

    return (
        <Page title="ReceiveInstallment">
            <Container maxWidth="lg">
                <Card sx={{padding:"1em"}}>
                    <Formik
                        initialValues={{
                            agreement_id:props.installment.agreement_id,
                            installment_plan_id:props.installment.id,
                            amount_paid:amountPaid,
                            extra:0,
                            remaining:0,
                            amount_due:'',
                            client: props.installment.client,
                            provider: 'SLEEK TRADING LTD.',
                            loan_amount: props.installment.loan_amount,
                            frequency: props.installment.frequency,
                            number_of_payments: props.installment.number_of_payments,
                            payment_amount: props.installment.payment_amount,
                            interest_rate: 0,
                            date:f_date
                        }}
                        onSubmit={values => {
                            if(amountPaid !== 0) {
                                values.amount_paid = amountPaid;
                                values.extra = extra;
                                values.remaining = remaining;
                                let e_b = calculated_values[currentIndex].beg_amt - amountPaid;
                                values.ending_balance = e_b;
                                values.beginning_balance = calculated_values[currentIndex].beg_amt;
                                values.amount_due = calculated_values[currentIndex].amt_due;
                                values.due_date = calculated_values[currentIndex].due_date;
                                setIsLoading(true);
                                props.installmentsUpdate(values);
                                props.scheduleUpdate(values);
                            } else {
                                values.extra = extra;
                                values.remaining = remaining;
                                let ending_balance = props.installment.loan_amount - amountPaid;
                                values.ending_balance = ending_balance;
                                props.installmentReceived();
                            }
                        }}
                    >
                        {({ errors, touched, isValidating }) => (
                            <Form>
                                <Stack sx={{ mb: 5 }}>
                                    <Typography sx={{ color: 'text.secondary' }}>Car Details</Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <b>Client:</b> {!_.isEmpty(props.installment.client) && props.installment.client}
                                        </Grid>
                                        <Grid item xs={6}>
                                            <b>Provider:</b> SLEEK TRADING LTD.
                                        </Grid>
                                        <Grid item xs={6}>
                                            <b>Loan Amount:</b> {props.installment.loan_amount}
                                        </Grid>
                                        <Grid item xs={6}>
                                            <b>Interest Rate:</b>  0.00%
                                        </Grid>
                                        <Grid item xs={6}>
                                            <b>Frequency:</b>  {!_.isEmpty(props.installment.frequency) && props.installment.frequency}
                                        </Grid>
                                        <Grid item xs={6}>
                                            <b>Number of Payments:</b>  {props.installment.number_of_payments}
                                        </Grid>
                                        <Grid item xs={6}>
                                            <b>Payment Amount:</b>  {props.installment.payment_amount}
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <TableContainer>
                                            <Table sx={{ minWidth: 650, marginTop:2 }} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>#</TableCell>
                                                        <TableCell>Date</TableCell>
                                                        <TableCell>Beg Amt</TableCell>
                                                        <TableCell>Amt Due</TableCell>
                                                        <TableCell>Amt Paid</TableCell>
                                                        <TableCell>Extra</TableCell>
                                                        <TableCell>Remaining</TableCell>
                                                        <TableCell>Ending Balance</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {renderTableBody()}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Stack>
                                <LoadingButton
                                    size="medium"
                                    type="submit"
                                    variant="contained"
                                    loading={isLoading}
                                    sx={{backgroundColor: '#c29136',float:"right"}}
                                >
                                    Update
                                </LoadingButton>
                            </Form>
                        )}
                    </Formik>
                </Card>
            </Container>
        </Page>
    );
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        alerts: state.alerts,
    }
}

export default connect(mapStateToProps, { installmentsCreate, installmentReceived, installmentsUpdate, scheduleUpdate })(ReceiveInstallment);

